<!--
 * @Author: CYX
 * @Date: 2020-05-12 11:45:15
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-13 15:04:49
--> 
<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  created() {
    //浏览器头部小图标
    this.getico();

    const oldKey = sessionStorage.getItem("tenantCodeName");
    const key = this.getUrlKey();
    if (key) {
      sessionStorage.setItem("tenantCodeName", key);
    }
      console.log(oldKey, key)

    if (!oldKey && !key) {
      console.log(oldKey, key)
      sessionStorage.setItem(
        "tenantCodeName",
        sessionStorage.getItem("defaultTenantCode")
      );
    }
  },
  methods:{
    async getico() {
      const data = {
        url: this.$baseURL + "/mallIco/getico.json",
        params: {
          icoSys: 2
        }
      };
      const res = await this.$post(data);
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      // console.log(res)
      if (res.data) {
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        // console.log(link,'0000')
        // link.href = 'http://www.stackoverflow.com/favicon.ico';
        link.href = this.vData.imgHeader + res.data.icoUrl;
        document.getElementsByTagName('head')[0].appendChild(link);
        console.log(link,'1111')
      }
    },
    getUrlKey() {
      const reg = new RegExp("(^|&)tenant_code=([^&]*)(&|$)", "i");
      const r = window.location.search.substr(1).match(reg) || [];
      return r[2];
    },
    reload () {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      })
    }
  },
  watch: {
    '$route': function (to, form) {
      if (to.path) {
        this.reload()
      }
    }
  }
}
</script>

<style lang="less">
@import url("~common/css/index");
body{
  .el-pagination button, .el-pagination span:not([class*=suffix]){
    vertical-align: middle;
  }
}
.el-form-item .el-form-item__label {
  word-wrap: normal;
}
</style>



// WEBPACK FOOTER //
// src/App.vue